import React from "react";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { fetchWalletSummary } from "../../store/slices/walletSlice";
import { formatDateTimeUtils } from "../../utils/comman";
import { useNavigate } from "react-router-dom";

const toDateInputValue = (d) => {
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  return `${yyyy}-${mm}-${dd}`;
};

const startOfDayIso = (yyyyMmDd) => {
  const d = new Date(`${yyyyMmDd}T00:00:00`);
  return d.toISOString();
};

const endOfDayIso = (yyyyMmDd) => {
  const d = new Date(`${yyyyMmDd}T23:59:59.999`);
  return d.toISOString();
};

const Transactions = () => {
  const dispatch = useAppDispatch();
  const { transactions, loading, error } = useAppSelector((s) => s.wallet);
  const today = React.useMemo(() => new Date(), []);
  const defaultFrom = React.useMemo(() => {
    const d = new Date();
    d.setDate(d.getDate() - 7);
    return d;
  }, []);

  const navigate = useNavigate();
  const [startDate, setStartDate] = React.useState(
    toDateInputValue(defaultFrom),
  );
  const [endDate, setEndDate] = React.useState(toDateInputValue(today));
  const [activeStatusFilter, setActiveStatusFilter] = React.useState("ALL");

  const load = React.useCallback(() => {
    dispatch(
      fetchWalletSummary({
        from_date: startOfDayIso(startDate),
        to_date: endOfDayIso(endDate),
      }),
    );
  }, [dispatch, startDate, endDate]);

  React.useEffect(() => {
    load();
  }, [load]);

  const filteredTransactions = React.useMemo(() => {
    if (activeStatusFilter === "ALL") return transactions;
    return transactions.filter(
      (tx) => String(tx?.txStatus || "").toUpperCase() === activeStatusFilter,
    );
  }, [transactions, activeStatusFilter]);

  const handleVeiwTransaction = (transactionId) => {
    navigate(`/transaction-details/${transactionId}`);
  };

  return (
    <section className="section accounts">
      <div className="row g-0">
        <div className="col-xl-12">
          <h2 className="userscreen-title">transactions</h2>
          <div className="form_search">
            <form
              noValidate
              onSubmit={(e) => {
                e.preventDefault();
                load();
              }}
            >
              <div className="row g-0">
                {/* <div className="col-md-2 col-6">
                <select
                  className="form-control"
                >
                  <option value="ALL" className="ng-star-inserted">
                    All Sports{" "}
                  </option>
                  <option value="4" className="ng-star-inserted">
                    Cricket{" "}
                  </option>
                  <option value="1" className="ng-star-inserted">
                    Football{" "}
                  </option>
                  <option value="2" className="ng-star-inserted">
                    Tennis{" "}
                  </option>
                  <option value="2378961" className="ng-star-inserted">
                    Politics{" "}
                  </option>
                  <option value="99998" className="ng-star-inserted">
                    Int Casino{" "}
                  </option>
                  <option value="99991" className="ng-star-inserted">
                    Sports book{" "}
                  </option>
                  <option value="7" className="ng-star-inserted">
                    Horse Racing{" "}
                  </option>
                  <option value="4339" className="ng-star-inserted">
                    Greyhound Racing{" "}
                  </option>
                  <option value="99990" className="ng-star-inserted">
                    Binary{" "}
                  </option>
                  <option value="99994" className="ng-star-inserted">
                    Kabaddi{" "}
                  </option>
                  <option value="7522" className="ng-star-inserted">
                    Basketball{" "}
                  </option>
                  <option value="7511" className="ng-star-inserted">
                    Baseball{" "}
                  </option>
                  <option value="20" className="ng-star-inserted">
                    Table Tennis{" "}
                  </option>
                  <option value="998917" className="ng-star-inserted">
                    Volleyball{" "}
                  </option>
                  <option value="7524" className="ng-star-inserted">
                    Ice Hockey{" "}
                  </option>
                  <option value="5" className="ng-star-inserted">
                    Rugby{" "}
                  </option>
                  <option value="26420387" className="ng-star-inserted">
                    Mixed Martial Arts{" "}
                  </option>
                  <option value="3503" className="ng-star-inserted">
                    Darts{" "}
                  </option>
                  <option value="29" className="ng-star-inserted">
                    Futsal{" "}
                  </option>
                </select>
              </div> */}
                <div className="col-md-2 col-6">
                  <input
                    type="date"
                    className="form-control"
                    value={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                  />
                </div>
                <div className="col-md-2 col-6">
                  <input
                    type="date"
                    className="form-control"
                    value={endDate}
                    onChange={(e) => setEndDate(e.target.value)}
                  />
                </div>
                <div className="col-md-2 col-6">
                  <button
                    type="submit"
                    className="btn btn-fs"
                    disabled={loading}
                  >
                    get transactions
                  </button>
                </div>
                <div className="col-md-4 col-12 text-md-end text-center">
                  <div className="document_button"></div>
                </div>
              </div>
            </form>
          </div>
          <div className="col-12">
            <div
              className="quick-filters mb-2"
              style={{ justifyContent: "flex-start", flexWrap: "wrap" }}
            >
              <div
                className={`quick-filter ${activeStatusFilter === "ALL" ? "active-filter" : ""}`}
                onClick={() => setActiveStatusFilter("ALL")}
                onKeyDown={(e) =>
                  e.key === "Enter" && setActiveStatusFilter("ALL")
                }
                role="button"
                tabIndex={0}
              >
                All
              </div>
              <div
                className={`quick-filter ${activeStatusFilter === "ACCEPTED" ? "active-filter" : ""}`}
                onClick={() => setActiveStatusFilter("ACCEPTED")}
                onKeyDown={(e) =>
                  e.key === "Enter" && setActiveStatusFilter("ACCEPTED")
                }
                role="button"
                tabIndex={0}
              >
                Approved
              </div>
              <div
                className={`quick-filter ${activeStatusFilter === "PENDING" ? "active-filter" : ""}`}
                onClick={() => setActiveStatusFilter("PENDING")}
                onKeyDown={(e) =>
                  e.key === "Enter" && setActiveStatusFilter("PENDING")
                }
                role="button"
                tabIndex={0}
              >
                Pending
              </div>
              <div
                className={`quick-filter ${activeStatusFilter === "HOLD" ? "active-filter" : ""}`}
                onClick={() => setActiveStatusFilter("HOLD")}
                onKeyDown={(e) =>
                  e.key === "Enter" && setActiveStatusFilter("HOLD")
                }
                role="button"
                tabIndex={0}
              >
                Hold
              </div>
              <div
                className={`quick-filter ${activeStatusFilter === "REJECTED" ? "active-filter" : ""}`}
                onClick={() => setActiveStatusFilter("REJECTED")}
                onKeyDown={(e) =>
                  e.key === "Enter" && setActiveStatusFilter("REJECTED")
                }
                role="button"
                tabIndex={0}
              >
                Rejected
              </div>
            </div>
          </div>
          <div className="table-responsive">
            <table className="datatable table table-striped table-bordered">
              <thead>
                <tr>
                  <th>No</th>
                  <th>date</th>
                  <th>Type</th>
                  <th>Amount</th>
                  <th>Status</th>
                  <th>Payment Method</th>
                  <th>Remark</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {loading && (
                  <tr>
                    <td colSpan={7} className="text-center">
                      Loading...
                    </td>
                  </tr>
                )}
                {!loading && error && (
                  <tr>
                    <td colSpan={7} className="text-center text-danger">
                      {String(error)}
                    </td>
                  </tr>
                )}
                {!loading && !error && transactions.length === 0 && (
                  <tr>
                    <td colSpan={7} className="noData text-center">
                      No Data Found
                    </td>
                  </tr>
                )}
                {!loading &&
                  !error &&
                  filteredTransactions.map((tx, idx) => (
                    <tr key={tx.transactionId || idx}>
                      <td>{idx + 1}</td>
                      <td>{formatDateTimeUtils(tx.startTime)}</td>
                      <td>{tx.transactionType}</td>
                      <td>₹ {Number(tx.amount || 0).toFixed(2)}</td>
                      <td>{tx.txStatus}</td>
                      <td>{tx.paymentMethod}</td>
                      <td>{tx.notes}</td>
                      <td>
                        <button
                          className="btn btn-sm btn-thmemes"
                          onClick={() =>
                            handleVeiwTransaction(tx.transactionId)
                          }
                        >
                          View
                        </button>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Transactions;
